import React from 'react';
import { AudioResult, SessionDataResult } from '../../../../interfaces/services';
import { Controls } from './Controls';
import { AudioPlayerBar } from './Timeline';
import { AudioPlayer } from './AudioPlayer';
import { calculateTotalDuration } from './timeUtils';
import { prospectPartyCode } from '../../../../cfg/endpoints';

export interface TranscriptAudioProps {
  data: SessionDataResult;  
  currentTimeInMs: number;
  isPlaying: boolean;
  previousPlayState: boolean;
  updateTime: (time?: number, isActive?: boolean, prevActive?: boolean) => void;
  setSpeed: (idx: number) => void;
  speed: number;
  totalDuration: number;
}

export const TranscriptAudio: React.FC<TranscriptAudioProps> = ({
  currentTimeInMs,
  isPlaying,
  previousPlayState,
  data,
  updateTime,
  setSpeed,
  speed,
  totalDuration
}) => {
  // Handle play/pause toggle
  const handlePlayPause = () => updateTime(undefined, !isPlaying, isPlaying);
  const handleTimelineUpdate = (percentage: number) => {
    if (totalDuration) {
      const newTime = percentage * totalDuration;
      updateTime(newTime, undefined);
    }
  }

  // Handle mouse down on timeline - pause playback while scrubbing
  const handleMouseDown = () => {
    if (isPlaying) { updateTime(undefined, false, true) }
  }

  // Handle mouse up on timeline - resume playback if we were playing before
  const handleMouseUp = () => {
    if (previousPlayState) { updateTime(undefined, true, false) }
  }
  const prospectNotRecorded = data.audio.find((value: AudioResult) => value.party_code === prospectPartyCode) === undefined
  return (
    <div className="min-h-fit w-full bg-white border-t border-gray-200 flex flex-row gap-2 overflow-hidden pt-2 pl-2 pr-2">
      <Controls 
        isPlaying={isPlaying} 
        currentSpeed={speed} 
        currentTimeInMS={currentTimeInMs} 
        endTime={totalDuration}
        onPlayPause={handlePlayPause} 
        onSpeedChange={setSpeed} 
      />
      <AudioPlayerBar
        currentTime={currentTimeInMs}
        updateCurrentTime={handleTimelineUpdate}
        endTime={totalDuration}
        turns={data?.turns || []}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        play={isPlaying}
        prospectNotRecorded={prospectNotRecorded}
      />
      
      {/* Audio player component that handles actual audio playback */}
      <AudioPlayer
        sessionId={data.session.session_id}
        currentTimeInMS={currentTimeInMs}
        isPlaying={isPlaying}
        speed={speed}
        data={{
          'audio': data.audio,
          'audio_links': data.audio_links,
          'session': data.session,
        }}
      />
    </div>
  );
}
